import React from 'react';

import { RootStateOrAny, useSelector } from 'react-redux';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { Paragraph } from '../../styles/paragraph';
import { useLDNewShoppingBagUX } from '../../utils/LD/useNewShoppingBagUX';

const TitleParagraph = styled(Paragraph)`
  ${({ theme }) => theme.paragraph.variants.paragraph3Uppercase.textStyles};
  align-self: start;
`;

const CartDrawerHeaderTitleMessageWithCount = () => {
  const count = useSelector(
    ({ checkout }: RootStateOrAny) => checkout.itemCount
  );

  return (
    <TitleParagraph>
      <FormattedMessage
        id="global_checkout.cart_title_your_bag_with_count"
        defaultMessage="Your Bag ({count})"
        values={{ count: count }}
      />
    </TitleParagraph>
  );
};

export const CartDrawerHeaderTitleMessage = () => {
  const { isControl } = useLDNewShoppingBagUX();
  if (isControl) {
    return (
      <FormattedMessage
        id="global_checkout.cart_title_your_bag"
        defaultMessage="Your Bag"
      />
    );
  }
  return <CartDrawerHeaderTitleMessageWithCount />;
};
